import React, { useContext } from 'react';
import styles from './ResetPass.module.scss';
import { LogoDark } from 'esa-ui-library';
import { ResetForm } from './components';
import { useStore } from '../../../common';
import { AuthContext } from '../../../logic';

const ResetPass = (): JSX.Element => {
	const [, dispatch] = useStore(false);
	const { logout } = useContext(AuthContext);

	const onResetSubmit = () => {
		dispatch('RESET_SUBMIT', logout);
	};

	const renderReset = () => (
		<>
			<h2>Reset Password</h2>
			<p className={styles.Explanation}>Please enter your new password.</p>
			<ResetForm onSubmit={onResetSubmit} />
		</>
	);

	return (
		<section className={styles.Reset}>
			<section>
				<LogoDark />
				<div className={styles.ResetContent}>{renderReset()}</div>
			</section>
		</section>
	);
};

export { ResetPass };
